import {
  ExpensesEntitiesExpensableStatusEnum,
  ExpensesExpensableFiltersInput,
} from 'generated/resources/datatable.graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateToString } from 'modules/core/lib/dates'

type ExpensesListUrlParams = {
  filters: ExpensesExpensableFiltersInput
  status: ExpensesEntitiesExpensableStatusEnum
  startDate?: Date
  endDate?: Date
}

export const useReportNavigation = () => {
  const { navigation } = useNavigation()

  const buildExpensesListUrl = ({
    filters,
    status,
    startDate,
    endDate,
  }: ExpensesListUrlParams): string => {
    const searchParams = new URLSearchParams()

    searchParams.append('currency', filters.currency)

    if (filters.legalEntityIds?.length) {
      searchParams.append('legalEntityIds', filters.legalEntityIds.join(','))
    }
    if (filters.employeeIds?.length) {
      searchParams.append('employeeIds', filters.employeeIds.join(','))
    }
    if (filters.creationType) {
      searchParams.append('creationType', filters.creationType)
    }
    searchParams.append('status', status)
    if (startDate) {
      searchParams.append('startDate', dateToString(startDate, 'backend'))
    }
    if (endDate) {
      searchParams.append('endDate', dateToString(endDate, 'backend'))
    }

    const queryString = searchParams.toString()
    return `${navigation.expenses.list.expenses.fullPath()}?${queryString}`
  }

  return {
    buildExpensesListUrl: buildExpensesListUrl,
  }
}
